import { getStore } from "../store/Store";

export default function isItemInPreviewPaneViewState(itemId: string): boolean {
    const { itemPrintPaneViewStates } = getStore();
    
    for (const tabId of itemPrintPaneViewStates.keys()) {
        if (itemPrintPaneViewStates.get(tabId)?.itemId == itemId) {
            return true;
        }
    }
    
    return false;
}
